class TooltipManagement {

    constructor() {
        this.body = document.body;
        this.manageTooltip();
    }

    manageTooltip() {
        if (this.body.classList.contains('rpc-page')) {

            const TOOLTIP          = document.querySelector('.tooltip');
            const EXCLAMATION_MARK = document.querySelector('.exclamation-mark');
            const CLOSE_TOOLTIP    = document.querySelector('.close-tooltip-parent').querySelector('span');

            EXCLAMATION_MARK.addEventListener('click', () => TOOLTIP.classList.toggle('active'));
            CLOSE_TOOLTIP.addEventListener('click', () => TOOLTIP.classList.remove('active'));

        } else if (this.body.classList.contains('main-page-site')) {

            this.swiper        = document.querySelector('main > .swiper-container').swiper;
            const ALL_SECTIONS = document.getElementsByTagName("section");

            for (let i = 0; i < ALL_SECTIONS.length; i++) {
                if (ALL_SECTIONS[i].querySelector(".tooltip")) {
                    const EXCLAMATION_MARK = ALL_SECTIONS[i].querySelectorAll(".exclamation-mark");

                    for (let j = 0; j < EXCLAMATION_MARK.length; j++) {
                        EXCLAMATION_MARK[j].addEventListener("click", () => {
                            const PARENT = EXCLAMATION_MARK[j].parentElement.parentElement;
                            if (PARENT.classList.contains('with-popup')) {
                                this.displayPopup(EXCLAMATION_MARK[j]);
                            } else {
                                EXCLAMATION_MARK[j].parentElement.querySelector('.tooltip').classList.toggle("active");
                                const TOOLTIP       = EXCLAMATION_MARK[j].parentElement.querySelector('.tooltip');
                                const CLOSE_TOOLTIP = TOOLTIP.querySelector('.close-tooltip-parent').querySelector('span');
                                CLOSE_TOOLTIP.addEventListener('click', () => TOOLTIP.classList.remove('active'));
                            }
                        });
                    }
                }
            }

            const CLOSE_BTN = document.getElementsByClassName('popup-close');

            for (let i = 0; i < CLOSE_BTN.length; i++) {
                CLOSE_BTN[i].addEventListener('click', () => {
                    CLOSE_BTN[i].parentElement.classList.remove('active');
                })
            }
        }
    }

    displayPopup(tooltip) {
        const POPUP = document.querySelector(tooltip.getAttribute('data-target'));

        POPUP.classList.add('active');
    }
}